module.exports = __webpack_public_path__ + "static/media/confirm_woman.0820392e.png";